import {
  useState,
  useContext
} from "react";


import {
  motion,
  AnimatePresence
} from "framer-motion";

import axios
  from "../utils/axiosInstance";

import { useNavigate, Link } from "react-router-dom";

import {
  useAuth
} from "../context/AuthContext";
import {
  CartContext
} from "../context/CartContext";
import {
  WishlistContext
} from "../context/WishlistContext";

import {
  useAuthModal
} from "../context/AuthModalContext";

function AuthModal() {

  const {
    isOpen,
    closeAuthModal,
    redirectAfterAuth
  } = useAuthModal();

  const {
    login: contextLogin
  } = useAuth();
const {
  addToCart
} = useContext(CartContext);

const {
  addToWishlist
} = useContext(WishlistContext);

  const navigate = useNavigate();

  const [activeTab, setActiveTab] =
    useState("login");

  const [loading, setLoading] =
    useState(false);

  const [loginForm, setLoginForm] =
    useState({
      email: "",
      password: ""
    });

  const [registerForm,
    setRegisterForm] =
    useState({
      name: "",
      email: "",
      password: ""
    });

  /* ===============================
     LOGIN
  =============================== */

  const handleLogin = async () => {

    try {

      setLoading(true);

      const res = await axios.post(
        "/api/auth/login",
        loginForm
      );

      const token =
        res.data.token;

      const role =
        res.data.role;

      localStorage.setItem(
        "token",
        token
      );

      localStorage.setItem(
        "email",
        loginForm.email
      );

      localStorage.setItem(
        "role",
        role
      );

      contextLogin(
        token,
        loginForm.email
      );

      /* RESTORE PENDING CART */

      const pendingVariant =
        localStorage.getItem(
          "pendingCartVariant"
        );

      if (pendingVariant) {

        try {

          await addToCart(
            Number(pendingVariant)
          );

          localStorage.removeItem(
            "pendingCartVariant"
          );

        } catch (err) {

          console.error(
            "Failed restoring cart item",
            err
          );

        }

      }

      /* RESTORE WISHLIST */

      const pendingWishlist =
        localStorage.getItem(
          "pendingWishlistProduct"
        );

      if (pendingWishlist) {

        try {

          await addToWishlist(
            Number(pendingWishlist)
          );

          localStorage.removeItem(
            "pendingWishlistProduct"
          );

        } catch (err) {

          console.error(err);

        }

      }

      /* BUY NOW */

      const pendingBuyNow =
        localStorage.getItem(
          "pendingBuyNowVariant"
        );

      if (pendingBuyNow) {

        try {

          await addToCart(
            Number(pendingBuyNow)
          );

          localStorage.removeItem(
            "pendingBuyNowVariant"
          );

          closeAuthModal();

          navigate("/checkout");

          return;

        } catch (err) {

          console.error(err);

        }

      }

      closeAuthModal();

      navigate(
        redirectAfterAuth || "/"
      );

    } catch (err) {

      console.error(err);

      alert(
        "Invalid credentials"
      );

    } finally {

      setLoading(false);

    }

  };

  /* ===============================
     REGISTER
  =============================== */

  const handleRegister = async () => {

    try {

      setLoading(true);

      await axios.post(
        "/api/auth/register",
        registerForm
      );

      const loginRes =
        await axios.post(
          "/api/auth/login",
          {
            email:
              registerForm.email,

            password:
              registerForm.password
          }
        );

      const token =
        loginRes.data.token;

      const role =
        loginRes.data.role;

      localStorage.setItem(
        "token",
        token
      );

      localStorage.setItem(
        "email",
        registerForm.email
      );

      localStorage.setItem(
        "role",
        role
      );

      contextLogin(
        token,
        registerForm.email
      );

      /* RESTORE PENDING CART */

      const pendingVariant =
        localStorage.getItem(
          "pendingCartVariant"
        );

      if (pendingVariant) {

        try {

          await addToCart(
            Number(pendingVariant)
          );

          localStorage.removeItem(
            "pendingCartVariant"
          );

        } catch (err) {

          console.error(
            "Failed restoring cart item",
            err
          );

        }

      }

      /* RESTORE WISHLIST */

      const pendingWishlist =
        localStorage.getItem(
          "pendingWishlistProduct"
        );

      if (pendingWishlist) {

        try {

          await addToWishlist(
            Number(pendingWishlist)
          );

          localStorage.removeItem(
            "pendingWishlistProduct"
          );

        } catch (err) {

          console.error(err);

        }

      }

      /* BUY NOW */

      const pendingBuyNow =
        localStorage.getItem(
          "pendingBuyNowVariant"
        );

      if (pendingBuyNow) {

        try {

          await addToCart(
            Number(pendingBuyNow)
          );

          localStorage.removeItem(
            "pendingBuyNowVariant"
          );

          closeAuthModal();

          navigate("/checkout");

          return;

        } catch (err) {

          console.error(err);

        }

      }

      closeAuthModal();

      navigate(
        redirectAfterAuth || "/"
      );

    } catch (err) {

      console.error(err);

      alert(
        err?.response?.data ||
        "Registration failed"
      );

    } finally {

      setLoading(false);

    }

  };

  return (

    <AnimatePresence>

      {isOpen && (

        <motion.div

          initial={{
            opacity: 0
          }}

          animate={{
            opacity: 1
          }}

          exit={{
            opacity: 0
          }}

          className="
            fixed inset-0
            z-[9999]

            bg-black/50

            backdrop-blur-sm

            flex items-center justify-center

            p-4
          "
        >

          {/* MODAL */}

          <motion.div

            initial={{
              opacity: 0,
              y: 30,
              scale: 0.95
            }}

            animate={{
              opacity: 1,
              y: 0,
              scale: 1
            }}

            exit={{
              opacity: 0,
              y: 20,
              scale: 0.95
            }}

            transition={{
              duration: 0.35
            }}

            className="
              relative

              w-full
              max-w-md

              rounded-[2.5rem]

              overflow-hidden

              bg-white/80

              backdrop-blur-2xl

              border border-white/60

              shadow-[0_20px_80px_rgba(0,0,0,0.18)]

              p-8 md:p-10
            "
          >

            {/* CLOSE */}

            <button

              onClick={closeAuthModal}

              className="
                absolute top-5 right-5

                w-10 h-10

                rounded-full

                bg-stone-100

                hover:bg-stone-200

                transition
              "
            >
              ✕
            </button>

            {/* TOP */}

            <div className="text-center mb-8">

              <p className="
                text-[10px]

                uppercase

                tracking-[0.4em]

                text-stone-400

                mb-3
              ">
                Welcome to
              </p>

              <h2 className="
                text-4xl

                font-serif
                italic

                mb-4
              ">
                Isabi Studio
              </h2>

              <p className="
                text-stone-500

                text-sm
              ">
                Join our sacred handcrafted art experience.
              </p>

            </div>

            {/* TABS */}

            <div className="
              flex

              bg-stone-100

              rounded-full

              p-1

              mb-8
            ">

              <button

                onClick={() =>
                  setActiveTab("login")
                }

                className={`
                  flex-1

                  py-3

                  rounded-full

                  text-sm

                  transition-all duration-500

                  ${
                    activeTab === "login"

                      ? `
                        bg-black
                        text-white
                      `

                      : `
                        text-stone-600
                      `
                  }
                `}
              >
                Login
              </button>

              <button

                onClick={() =>
                  setActiveTab("register")
                }

                className={`
                  flex-1

                  py-3

                  rounded-full

                  text-sm

                  transition-all duration-500

                  ${
                    activeTab === "register"

                      ? `
                        bg-black
                        text-white
                      `

                      : `
                        text-stone-600
                      `
                  }
                `}
              >
                Register
              </button>

            </div>

            {/* LOGIN */}

            {activeTab === "login" ? (

              <div className="space-y-5">

                <input
                  type="email"
                  placeholder="Email"
                  value={loginForm.email}
                  onChange={(e) =>
                    setLoginForm({
                      ...loginForm,
                      email: e.target.value
                    })
                  }
                  className="
                    w-full

                    rounded-2xl

                    border border-stone-200

                    bg-white

                    px-5 py-4

                    outline-none

                    focus:border-black
                  "
                />

                <input
                  type="password"
                  placeholder="Password"
                  value={loginForm.password}
                  onChange={(e) =>
                    setLoginForm({
                      ...loginForm,
                      password: e.target.value
                    })
                  }
                  className="
                    w-full

                    rounded-2xl

                    border border-stone-200

                    bg-white

                    px-5 py-4

                    outline-none

                    focus:border-black
                  "
                />
                {/* ADD THIS ↓ */}
                <div className="text-right -mt-2">
                  <Link
                    to="/forgot-password"
                    onClick={closeAuthModal}
                    className="text-xs text-stone-400 hover:text-black transition"
                  >
                    Forgot password?
                  </Link>
                </div>

                <button

                  onClick={handleLogin}

                  disabled={loading}

                  className="
                    w-full

                    py-4

                    rounded-full

                    bg-black

                    text-white

                    uppercase

                    tracking-[0.25em]

                    hover:bg-stone-800

                    transition-all duration-500
                  "
                >
                  {
                    loading
                      ? "Please wait..."
                      : "Login"
                  }
                </button>

              </div>

            ) : (

              /* REGISTER */

              <div className="space-y-5">

                <input
                  type="text"
                  placeholder="Full Name"
                  value={registerForm.name}
                  onChange={(e) =>
                    setRegisterForm({
                      ...registerForm,
                      name: e.target.value
                    })
                  }
                  className="
                    w-full

                    rounded-2xl

                    border border-stone-200

                    bg-white

                    px-5 py-4

                    outline-none

                    focus:border-black
                  "
                />

                <input
                  type="email"
                  placeholder="Email"
                  value={registerForm.email}
                  onChange={(e) =>
                    setRegisterForm({
                      ...registerForm,
                      email: e.target.value
                    })
                  }
                  className="
                    w-full

                    rounded-2xl

                    border border-stone-200

                    bg-white

                    px-5 py-4

                    outline-none

                    focus:border-black
                  "
                />

                <input
                  type="password"
                  placeholder="Password"
                  value={registerForm.password}
                  onChange={(e) =>
                    setRegisterForm({
                      ...registerForm,
                      password: e.target.value
                    })
                  }
                  className="
                    w-full

                    rounded-2xl

                    border border-stone-200

                    bg-white

                    px-5 py-4

                    outline-none

                    focus:border-black
                  "
                />

                <button

                  onClick={handleRegister}

                  disabled={loading}

                  className="
                    w-full

                    py-4

                    rounded-full

                    bg-black

                    text-white

                    uppercase

                    tracking-[0.25em]

                    hover:bg-stone-800

                    transition-all duration-500
                  "
                >
                  {
                    loading
                      ? "Please wait..."
                      : "Create Account"
                  }
                </button>

              </div>

            )}

            {/* FOOTER */}

            <div className="
              mt-8

              text-center

              text-xs

              text-stone-400
            ">
              🔒 Secure authentication • Premium experience
            </div>

          </motion.div>

        </motion.div>

      )}

    </AnimatePresence>

  );

}

export default AuthModal;